export default {
  now: new Date(),
  chat: {
    show: false,
    chats: [],
  },
};
